import {saveAs as importedSaveAs} from 'file-saver';

export class Utils {
  public static downLoadFile(data: any, type: string, filename: string) {
    const blob = new Blob([data], {type: type});

    importedSaveAs(blob, filename);
  }

  public static extractStrengthFromString(strengthText: String): number {
    const indexOfSpace = strengthText.indexOf(' ');

    return Number(strengthText.substr(0, indexOfSpace));
  }
}
